import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { UpdateWatchlistConfirmationDetails } from 'AgentApp/ts/interfaces/agent-event';

@Component({
    selector: 'ycn-update-watchlist-confirmation-details',
    imports: [],
    templateUrl: './update-watchlist-confirmation-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateWatchlistConfirmationDetailsComponent {
    protected readonly details = input.required<UpdateWatchlistConfirmationDetails>();
}
